/** PagesEnum 自动生成请勿修改  */ 
/** @InjectPages **/ 
import lodash from 'lodash';
import React from 'react';
export const PagesEnum = {
    /** /  @/pages/index/index.tsx */ 
    Home:'/',
    /** /function/qrcode  @/pages/function/qrcode/index.tsx */ 
    Function_qrcode:'/function/qrcode',
    /** /function/reseturl  @/pages/function/reseturl/index.tsx */ 
    Function_reseturl:'/function/reseturl',
    /** /lenovoid/bindmobile  @/pages/lenovoid/bindmobile/index.tsx */ 
    Lenovoid_bindmobile:'/lenovoid/bindmobile',
    /** /loginout  @/pages/loginout/index.tsx */ 
    Loginout:'/loginout',
    /** /micro/:micro  @/pages/micro/[micro].tsx */ 
    Micro_micro:'/micro/:micro',
    /** /middlepage/lexiang  @/pages/middlepage/lexiang/index.tsx */ 
    Middlepage_lexiang:'/middlepage/lexiang',
    /** /middlepage/live  @/pages/middlepage/live/index.tsx */ 
    Middlepage_live:'/middlepage/live',
    /** /middlepage/shop  @/pages/middlepage/shop/index.tsx */ 
    Middlepage_shop:'/middlepage/shop',
    /** /middlepage/upstream  @/pages/middlepage/upstream/index.tsx */ 
    Middlepage_upstream:'/middlepage/upstream',
    /** /middlepage/yxt  @/pages/middlepage/yxt/index.tsx */ 
    Middlepage_yxt:'/middlepage/yxt',
    /** /oauth2/authorize  @/pages/oauth2/authorize/index.tsx */ 
    Oauth_2_authorize:'/oauth2/authorize',
    /** /personal  @/pages/personal/index/index.tsx */ 
    Personal:'/personal',
    /** /personal/bindmobile  @/pages/personal/bindmobile/index.tsx */ 
    Personal_bindmobile:'/personal/bindmobile',
    /** /personal/bindwechat  @/pages/personal/bindwechat/index/index.tsx */ 
    Personal_bindwechat:'/personal/bindwechat',
    /** /personal/bindwechat/qrcode  @/pages/personal/bindwechat/qrcode/index.tsx */ 
    Personal_bindwechat_qrcode:'/personal/bindwechat/qrcode',
    /** /personal/changemobile  @/pages/personal/changemobile/index.tsx */ 
    Personal_changemobile:'/personal/changemobile',
    /** /personal/editpwd  @/pages/personal/editpwd/index.tsx */ 
    Personal_editpwd:'/personal/editpwd',
    /** /personal/forgetpwd  @/pages/personal/forgetpwd/index.tsx */ 
    Personal_forgetpwd:'/personal/forgetpwd',
    /** /personal/lowresetpsd  @/pages/personal/lowresetpsd/index.tsx */ 
    Personal_lowresetpsd:'/personal/lowresetpsd',
    /** /personal/resetpwd  @/pages/personal/resetpwd/index.tsx */ 
    Personal_resetpwd:'/personal/resetpwd',
    /** /register  @/pages/register/index/index.tsx */ 
    Register:'/register',
    /** /register/activation  @/pages/register/activation/index.tsx */ 
    Register_activation:'/register/activation',
    /** /register/bindmobile  @/pages/register/bindmobile/index.tsx */ 
    Register_bindmobile:'/register/bindmobile'
}
lodash.set(React, '$Pages', PagesEnum)
Object.defineProperty(React.Component.prototype, '$Pages', {
    get: lodash.constant(React.$Pages)
})
declare module 'react' {
    const $Pages: typeof PagesEnum
    interface Component {
        readonly $Pages: typeof PagesEnum
    }
}
/** @InjectPages **/